import { useDispatch } from "react-redux";

import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import { deleteBlog } from "store/actions/blogsAction";

function DeletePostModel({ isOpen, toggle, data }) {
  const dispatch = useDispatch();

  const handleDelete = () => {
    dispatch(
      deleteBlog(data?.id, () => {
        toggle();
      })
    );
  };
  return (
    <Modal toggle={toggle} isOpen={isOpen} centered="true">
      <ModalBody>
        <div className="d-flex justify-content-center align-items-center mt-5">
          <h4> Are you sure you want to Delete Post ?</h4>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="danger" onClick={handleDelete}>
          Yes
        </Button>
        <Button color="warning" onClick={toggle}>
          No
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default DeletePostModel;
